export class CancellationError extends Error {
	constructor() {
		super('Cancellation Error was thrown');
	}
}
